import { defineMessages } from 'react-intl'

const scope = `procurify.expenses.ExpenseRequestPage`

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Create new expense report',
  },
  expenseStatusBreadcrumb: {
    id: `${scope}.expenseStatusBreadcrumb`,
    defaultMessage: 'Expense status',
  },
})
